// Italian translation - uses English as fallback for now
import { privacyEn } from './privacy.en';

export const privacyIt = privacyEn;
